export default {
  error: state => state.error,
  formLoading: state => state.formLoading,
  success: state => state.success,
  loading: state => state.loading,
  account: state => state.account,
  accounts: state => state.accounts,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Accounts/getters.js